import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Link,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import adminService from "../../../../services/admin.service";
import ClickAwayListener from '@mui/material/ClickAwayListener';

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const GoalComponentEdit = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
        getListIcon()
    }, []);

    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },

        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        disabled: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            }
        },

    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: cycleID } });
    }
    const classes = useStyles();
    let { serial, cycleID } = useParams()

    const [List, setList] = React.useState({
        config: [
            {
                color: "#BF9257",
            },
            {
                color: "#C1774E",
            },
            {
                color: "#4B8178",
            },
            {
                color: "#5D9ABE",
            },
            {
                color: "#336AA1",
            },
            {
                color: "#6A5A93",
            },
            {
                color: "#9C5684",
            },
            {
                color: "#984343",
            },
            {
                color: "#EFB76D",
            },
            {
                color: "#F19562",
            },
            {
                color: "#5DA196",
            },
            {
                color: "#74C1ED",
            },
            {
                color: "#4085C9",
            },
            {
                color: "#8470B8",
            },
            {
                color: "#C36BA5",
            },
            {
                color: "#BE5454",
            },
            {
                color: "#F7DBB6",
            },
            {
                color: "#F8CAB1",
            },
            {
                color: "#AED0CA",
            },
            {
                color: "#BAE0F6",
            },
            {
                color: "#9FC2E4",
            },
            {
                color: "#D8D3E9",
            },
            {
                color: "#E1B5D2",
            },
            {
                color: "#DFA9A9",
            },
            {
                color: "#FDF8F0",
            },
            {
                color: "#FEF4EF",
            },
            {
                color: "#EFF6F4",
            },
            {
                color: "#F1F9FD",
            },
            {
                color: "#ECF3FA",
            },
            {
                color: "#F3F1F8",
            },
            {
                color: "#F9F0F6",
            },
            {
                color: "#F9EEEE",
            },
        ]
    });
    const [status, setStatus] = React.useState(true);
    const [iconIcon, setIconIcon] = React.useState("");
    const [btnIcon, setBtnIcon] = React.useState("");
    const [colorIcon, setColorIcon] = React.useState("");
    const [openIcon, setOpenIcon] = React.useState(false);
    const [backgroundColorValue, setBackgroundColorValue] = React.useState("#5DA196");
    const [backgroundColorStatus, setBackgroundColorStatus] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [dataIcon, setDataIcon] = React.useState([]);
    const [edit, setEdit] = React.useState(false);
    const [adjust, setAdjust] = React.useState(true);
    const [name, setName] = React.useState("");
    const anchorRef = React.useRef(null);
    const [statusUse, setStatusUse] = React.useState(false);
    const handleStatus = () => {
        setStatus(!status)
    }
    const [formData, setFormData] = React.useState({
        code: '',
        nameEN: '',
        nameTH: '',
        icon: iconIcon,
        backgroundColor: backgroundColorValue,
        // status: status
    });

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
        "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
            backgroundColor: "#D8D8D8!important"
        }
    }));
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        nameEN: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        // nameTH: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        icon: yup.string().required(t('admin.inputForm.msgError.icon')),
        backgroundColor: yup.string().required(t('admin.inputForm.msgError.backgroundColor')),
    });
    const formik = useFormik({
        initialValues: {
            code: '',
            nameEN: '',
            nameTH: '',
            icon: iconIcon,
            backgroundColor: backgroundColorValue
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            submit(values)
            // openSuccessAddDialog(true)
        },
    });
    useEffect(() => {
        if (edit === false) {
            setEdit(true)
        }
    }, [formik.values, status]);
    const onOpenIcon = (color, btn, icon) => {
        setOpenIcon(true)
        // setIconIcon(icon)
        // setBtnIcon(btn)
        // setColorIcon(color['background-color'])
    }
    const onCloseIcon = () => {
        setOpenIcon(false)
        // setIconIcon("")
        // setBtnIcon("")
        // setColorIcon("")
    }
    const onSelectIcon = (data) => {
        // setIconIcon(data);
        formik.setFieldValue("icon", data)
    }
    const handleSubmit = () => {
        formik.submitForm()
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        clickLink('/admin/goal-component')
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    };
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/goal-component', { replace: false, state: { cycleID: cycleID } });
    }
    useEffect(() => {
        adminService.detailGoalCategory(serial).then(
            (response) => {
                let data = response?.data?.goal_category
                setName(response?.data?.goal_category?.name)
                // setAdjust(response?.data?.cycle?.options?.allow_adjust === true ? true : false)
                formik.setFieldValue("code", data?.code)
                formik.setFieldValue("nameEN", data?.options?.name_en !== undefined ? data?.options?.name_en : data?.name)
                formik.setFieldValue("nameTH", data?.options?.name_th !== undefined ? data?.options?.name_th : "")
                formik.setFieldValue("backgroundColor", data?.color)
                formik.setFieldValue("icon", data?.icon)
                setEdit(false)
                setStatus(data?.status === "active" ? true : false)
                setStatusUse(data?.is_used)
            },
        ).catch(() => {
        })
    }, []);
    const submit = (data) => {
        adminService.editGoalsCategory({
            cycle_id: cycleID,
            code: data.code,
            name_en: data.nameEN,
            name_th: data.nameTH,
            background_color: data.backgroundColor,
            icon: data.icon,
            status: status === true ? "active" : "inactive"
        }, serial).then(
            (response) => {
                openSuccessAddDialog(true)
            },
        ).catch(() => {
            seterrorText(t(`admin.label.GoalCategoryEditFail`))
            handleOpenFailedMessageDialog(true)
        })
    }
    const onOpenColor = () => {
        setBackgroundColorStatus(!backgroundColorStatus)
    }
    const setColor = (data) => {
        formik.setFieldValue("backgroundColor", data)
    }
    const getListIcon = () => {
        adminService.listIcon().then(
            (response) => {
                setDataIcon(response.data.icon)
            },
        )
    }
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setBackgroundColorStatus(false);
    };
    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/goal-component')}>{t('admin.label.goalComponent')}</span> / <span style={styles.end} >{t('admin.label.editGoalCategory')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {t('admin.label.editGoalCategory')}
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">

                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%' }} classes={{ root: classes.error }}>

                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "50px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code)}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.code')}
                                                classes={{ root: classes.input, root: classes.disabled }}
                                                disabled={true}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Box sx={{ paddingTop: "16px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0 }}
                                                        control={<IOSSwitch disabled={statusUse === true ? true : false} checked={status} onChange={() => handleStatus()} />}
                                                        label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography> */}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.nameEN')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.nameEN && formik.errors.nameEN)}
                                                fullWidth
                                                helperText={formik.touched.nameEN && formik.errors.nameEN}
                                                margin="normal"
                                                name="nameEN"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameEN}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.nameEN')}
                                                classes={{ root: adjust === true ? classes.input : classes.disabled }}
                                                disabled={adjust === true ? false : true}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.nameTH')}</Typography>
                                            <TextField
                                                // error={Boolean(touched.nameTH && errors.nameTH)}
                                                fullWidth
                                                // helperText={touched.nameTH && errors.nameTH}
                                                margin="normal"
                                                name="nameTH"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameTH}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.nameTH')}
                                                classes={{ root: adjust === true ? classes.input : classes.disabled }}
                                                disabled={adjust === true ? false : true}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", position: "relative" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.icon')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Box sx={{
                                                position: "relative",
                                                marginTop: "16px",
                                                ".MuiFormControl-root": {
                                                    marginTop: "0"
                                                }
                                            }}>
                                                <TextField
                                                    error={Boolean(formik.touched.icon && formik.errors.icon)}
                                                    fullWidth
                                                    helperText={formik.touched.icon && formik.errors.icon}
                                                    margin="normal"
                                                    name="icon"
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    type="text"
                                                    value={formik.values.icon}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    placeholder={t('admin.inputForm.placeholder.icon')}
                                                    classes={{ root: adjust === true ? classes.input : classes.disabled }}
                                                    disabled={adjust === true ? false : true}
                                                    inputProps={{ readOnly: true }}
                                                // size="small"
                                                />
                                                {adjust === true ? <Button sx={{ padding: "5.5px 8px !important", }} style={styles.buttonFile} onClick={e => onOpenIcon()}>{t('admin.inputForm.browse')}</Button> : null}
                                            </Box>
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={6} display="flex" sx={{ paddingTop: "0 !important" }}>
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <Box>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.backgroundColor')}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                    <Box sx={{
                                                        position: "relative",
                                                        marginTop: "16px",
                                                        ".MuiFormControl-root": {
                                                            marginTop: "0"
                                                        }
                                                    }}>
                                                        <Box py="5px" pl="7px" sx={{ display: "flex", position: "relative", cursor: "pointer", "align-items": "center", width: "130px", height: "40px", border: "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px" }} onClick={onOpenColor}>
                                                            <Box sx={{ "background-color": formik.values.backgroundColor, height: "28px", width: "85px", "border-radius": "3px" }} mr="15px"></Box>
                                                            <Dropdown style={{ color: "#404349", fontSize: "16px", fontWeight: "300" }} ></Dropdown>
                                                        </Box>
                                                        <Box sx={{ position: "absolute", "z-index": "9", }}>
                                                            <Box sx={{ "box-shadow": "0px 4px 10px rgb(0 0 0 / 10%)", "border-radius": "10px", overflow: "hidden", transition: "all .8s", "max-height": backgroundColorStatus ? "999px" : "0px", width: "max-content" }}>
                                                                <Box sx={{ width: "100%", "max-width": "540px", background: "white", "min-height": "400px", "padding": "30px 30px 44px", }}>
                                                                    <Typography fontSize={24} lineHeight="26.4px" color="#404349" fontWeight="500" pb="20px">Color</Typography>
                                                                    <Divider />
                                                                    <Box pt="20px" pb="25px" sx={{ ".MuiFormControl-root": { "margin-bottom": "0px" }, display: "flex", "align-items": "center", "margin": "0 -25px" }}>
                                                                        <Box sx={{ display: "flex", "align-items": "center", margin: "0 25px", width: "50%" }}>
                                                                            <Typography fontSize={16} lineHeight="24px" color="#404349" fontWeight="400" pr="30px">HEX</Typography>
                                                                            <TextField
                                                                                error={Boolean(formik.touched.backgroundColor && formik.errors.backgroundColor)}
                                                                                helperText={formik.touched.backgroundColor && formik.errors.backgroundColor}
                                                                                margin="normal"
                                                                                name="backgroundColor"
                                                                                // onBlur={handleBlur}
                                                                                onChange={formik.handleChange}
                                                                                type="text"
                                                                                value={formik.values.backgroundColor}
                                                                                variant="outlined"
                                                                                InputLabelProps={{
                                                                                    shrink: true,
                                                                                }}
                                                                                placeholder={t('admin.inputForm.placeholder.backgroundColor')}
                                                                                classes={{ root: adjust === true ? classes.input : classes.disabled }}
                                                                                disabled={adjust === true ? false : true}
                                                                            // size="small"
                                                                            />
                                                                        </Box>
                                                                        <Box sx={{ display: "flex", "align-items": "center", margin: "0 25px", width: "50%" }}>
                                                                            <Typography fontSize={16} lineHeight="24px" color="#404349" fontWeight="400" pr="30px">HEX</Typography>
                                                                            <Box sx={{ width: "100%", height: "41px", background: formik.values.backgroundColor, "border-radius": "4px" }} ></Box>
                                                                        </Box>
                                                                    </Box>
                                                                    <Typography fontSize={16} lineHeight="24px" pb="10px" color="#404349" fontWeight="400">Template Colors</Typography>
                                                                    <Box sx={{ margin: "-10px -10px", display: "flex", "flex-flow": "row wrap" }}>
                                                                        {List.config.length > 0 ?
                                                                            List.config.map(item => (
                                                                                <Box onClick={e => setColor(item.color)} sx={{ cursor: "pointer", backgroundColor: item.color, width: "40px", height: "40px", "border-radius": "3px", margin: "10px 11.25px" }}></Box>
                                                                            ))
                                                                            : null
                                                                        }
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </ClickAwayListener>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "40px 0px 20px 25px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", position: "relative" }}>
                                            <Divider></Divider>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", position: "relative" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.label.preview')}</Typography>
                                            {formik.values.icon !== "" ?
                                                <Box sx={{ backgroundColor: formik.values.backgroundColor, width: "80px", height: "80px", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "30px" }}>
                                                    <Icon sx={{ color: "#ffffff", "font-size": "50px" }}>{formik.values.icon}</Icon>
                                                </Box>
                                                :
                                                <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">-</Typography>
                                            }
                                        </Grid>
                                    </Grid>
                                    {adjust === true ?
                                        <Grid container mt={3} mb={3} pr={4} >
                                            <Grid item xs display="flex" flexDirection="row-reverse">
                                                <Box sx={{ width: "100px" }}>
                                                    <Button disabled={adjust === true ? edit === true ? false : true : true} onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                                        {t('label.save')}
                                                    </Button>
                                                </Box>
                                                <Box mr={2} sx={{ width: "100px" }}>
                                                    <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                                        {t('label.cancel')}
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        : null
                                    }

                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <DialogIcon open={openIcon} close={onCloseIcon} data={dataIcon} icon={onSelectIcon} />
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t(`admin.label.GoalCategoryEditSuccessfully`)}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={errorText + t(`dialog.label.tryAgain`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t("achievement.label.dialog.discardTitle")} text={t("achievement.label.dialog.discardText")} />
                </Container>
            </Box>
        </>
    )
};
export default GoalComponentEdit;
